import React from 'react';
import { Card, Icon } from 'ui';
import CornerRibbon from 'components/_shared/corner_ribbon.js';
import Text from 'components/shared/Text';
import CoverImage from '../CardCoverImage';

const COVER_WIDTH = 100;
const COVER_HEIGHT = 190;

const LearnTopicCard = ({
  counts,
  description,
  image,
  links: { view: viewUrl },
  name,
  featured,
}) => (
  <Card
    className="LearnTopicCard"
    cap={image ? null : 'left'}
    url={viewUrl}
    useRouter
  >
    {image && (
      <CoverImage image={image} width={COVER_WIDTH} height={COVER_HEIGHT} />
    )}
    {featured && <CornerRibbon type="warning" icon="star_filled" />}
    <Card.Content padding="medium" className="LearnTopicCard-content">
      <Text lines={2} className="LearnTopicCard-title ws-pr">
        {name}
      </Text>
      {description && (
        <Text lines={3} className="LearnTopicCard-description">
          {description}
        </Text>
      )}
      <div className="LearnTopicCard-footer">
        <Icon name="tags" className="mr-4" />
        {counts.formatted}
      </div>
    </Card.Content>
  </Card>
);

export default LearnTopicCard;
